import type { StoreObject, Reference } from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function identify(o: StoreObject | Reference): string | undefined {
    return getApolloClientInternal().cache.identify(o);
}
